module.exports = __webpack_public_path__ + "img/informationBig.497cc70c.png";